export const environment = {
  production: true,
  apiUrl: 'https://flow.capx.co.za',
  indexable: true,
  // Never expose the Debug menu / password-less Switch User in production.
  debug: false,
};
